<template>
  <v-menu
    v-model="showDatePicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="slide-y-transition"
    offset-y
    min-width="290px"
    :disabled="readonly"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="displayDate"
        readonly
        v-bind="$attrs"
        v-on="on"
        class="pr-1 mt-0 date-select"
        :class="{'readonly': readonly}"
        hide-details
        :clearable="clearable && !readonly"
        @click:clear="pickDate(null)"
      >
      </v-text-field>
    </template>
    <v-date-picker
      :value="date"
      @input="pickDate"
      :locale="getCurrentLocale()"
      :type="type"
      :first-day-of-week="1"
      :show-current="type === 'month' ? date : undefined"
      @change="$emit('change', $event)"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import {DateUtils} from '@/utils/date-utils';

export default {
  name: 'DateSelect',
  mixins: [
    LocaleUtils,
    DateUtils
  ],
  props: {
    label: {
      type: String
    },
    value: {
      default () {
        return null;
      }
    },
    type: {
      default () {
        return 'date';
      }
    },
    format: {
      type: String,
      default () {
        return this.type === 'month' ? 'MMMM YYYY' : 'L';
      }
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data () {
    return {
      showDatePicker: false,
    }
  },
  computed: {
    date() {
      if(this.value == null) {
        return null;
      }
      if(this.value instanceof Date) {
        return this.getIsoDateString(this.value);
      }
      if(typeof this.value === "string") {
        return this.value;
      }
      return null;
    },
    displayDate() {
      return this.date ? this.formatDate(this.date, this.format) : '';
    },
  },
  methods: {
    pickDate(newDate) {
      this.$emit('input', newDate);
      this.showDatePicker = false;
    }
  }
}
</script>

<style>
.date-select:not(.readonly) input {
  cursor: pointer;
}
</style>
